
const api = function (View) {
  View.prototype.organizations = function (n) {
    let m = this.match('#Organization+')
    return m.getNth(n)
  }
}
export default api
